import { useEffect } from 'react';
export const useRobotsDirective = (content) => {
    useEffect(() => {
        const existing = document.head.querySelector('meta[name="robots"]');
        const previousContent = existing ? existing.getAttribute('content') : null;
        const meta = existing ?? document.createElement('meta');
        if (!existing) {
            meta.setAttribute('name', 'robots');
            document.head.append(meta);
        }
        meta.setAttribute('content', content);
        return () => {
            if (existing) {
                if (previousContent === null)
                    existing.removeAttribute('content');
                else
                    existing.setAttribute('content', previousContent);
            }
            else {
                meta.remove();
            }
        };
    }, [content]);
};
